/*
* Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
* SPDX-License-Identifier: MIT
*
* Licensed under the MIT License. See the LICENSE accompanying this file
* for the specific language governing permissions and limitations under
* the License.
*/

import React, { useEffect, useState } from 'react';
import { AmplifyForgotPassword } from '@aws-amplify/ui-react';
import { Translations } from "@aws-amplify/ui-components";
import { I18n } from '@aws-amplify/core';
import { Auth } from "aws-amplify";
import * as Sentry from "@sentry/react";


const ForgotPassword = ({ onError }) => {
	const [currstate, setCurrstate] = useState();
	const [email, setEmail] = useState();

	useEffect(() => {
		const dictLang = {
			[Translations.RESET_YOUR_PASSWORD]: "Recupera Password",
			[Translations.SEND_CODE]: "Invia codice",
			[Translations.BACK_TO_SIGN_IN]: "Torna al Login",
			"Verification code": "Codice di verifica",
			"New password": "Nuova password",
			"Enter code": "Inserisci il codice ricevuto per mail",
			"Enter your new password": "Inserisci la nuova password che vuoi impostare",
			"Submit": "Conferma",
			"Invalid verification code provided, please try again.": "Il codice di verifica non è valido",
			"Password does not conform to policy: Password not long enough": "La password deve essere lunga almeno 8 caratteri e deve contenere almeno un carattere speciale (es. !, ?, ^)",
			"Attempt limit exceeded, please try after some time.": "Hai richiesto troppi codice di verifica, si prega di riprovare più tardi"
		};
		I18n.putVocabulariesForLanguage("it", dictLang);
		I18n.putVocabulariesForLanguage("en", dictLang);
	}, [])

	return currstate === "code" ?
		(
			<AmplifyForgotPassword className="forgot-password"
				usernameAlias="email"
				slot="forgot-password"
				formFields={[
					{
						type: "code",
						placeholder: "Inserisci il codice di verifica",
						required: true,
						label: `Codice di verifica`,
						inputProps: {
							"type": "text"
						}
					},
					{
						type: "password",
						placeholder: `Inserisci la nuova password`,
						required: true,
						label: "Nuova password",
					}
				]}
				sendButtonText='Modifica Password'
				handleSend={async (e) => {
					e.stopPropagation()
					e.preventDefault()
					onError && onError("")
					const code = e.target.code.value
					const password = e.target.password.value

					try {
						await Auth.forgotPasswordSubmit(email, code, password)
						//riporta i query parameters nella home
						window.location.href = `${window.location.origin}${window.location.search}`
					} catch (error) {
						Sentry.captureException(error);
						if (error?.message?.includes("Invalid verification code")) {
							onError("Codice di verifica non valido, riprovare.")
						} else if (error?.message?.includes("Member must satisfy regular expression pattern")) {
							onError("La password deve essere lunga almeno 8 caratteri e deve contenere almeno un carattere speciale (es. !, ?, ^)")
						} else {
							onError(error?.message || "Errore durante la richiesta")
						}
					}
				}}
			>
			</AmplifyForgotPassword>
		)

		: (
			<AmplifyForgotPassword className="forgot-password"
				usernameAlias="email"
				slot="forgot-password"
				formFields={[
					{
						type: "email",
						placeholder: "Inserisci la tua e-mail",
						required: true,
						label: "Indirizzo e-mail",
						hint: "Se l’email è associata ad un account esistente, riceverai un codice di verifica per modificare la password."
					},
				]}
				handleSend={async (e) => {
					e.stopPropagation()
					e.preventDefault()
					console.log("handleSend", e)
					onError && onError("")
					const email = e.target.email.value
					setEmail(email)
					try {
						await Auth.forgotPassword(email)
						setCurrstate("code")
					} catch (error) {
						if (error?.message?.includes("Attempt limit exceeded")) {
							onError("Il limite di tentativi è stato superato, riprovare più tardi.")
						} else {
							onError(error?.message || "Errore durante la richiesta")
						}

					}
				}}
			>
			</AmplifyForgotPassword>
		);
}

export default ForgotPassword;
